import React from 'react';

const Bowls = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 24 24'
            className={className}
        >
            <g clip-path='url(#clip0_14546_80179)'>
                <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M12 24C5.37259 24 0 18.6274 0 12C0 5.37259 5.37259 0 12 0C18.6274 0 24 5.37259 24 12C24 18.6274 18.6274 24 12 24ZM15.84 6C15.1773 6 14.64 5.46274 14.64 4.8C14.64 4.13726 15.1773 3.6 15.84 3.6C16.5027 3.6 17.04 4.13726 17.04 4.8C17.04 5.46274 16.5027 6 15.84 6ZM19.2 8.4C18.5373 8.4 18 7.86274 18 7.2C18 6.53726 18.5373 6 19.2 6C19.8627 6 20.4 6.53726 20.4 7.2C20.4 7.86274 19.8627 8.4 19.2 8.4ZM14.16 8.88C14.16 9.54274 14.6973 10.08 15.36 10.08C16.0227 10.08 16.56 9.54274 16.56 8.88C16.56 8.21726 16.0227 7.68 15.36 7.68C14.6973 7.68 14.16 8.21726 14.16 8.88Z'
                />
            </g>
        </svg>
    );
};

export default Bowls;
